import axios from "axios";
import { getUrl } from "../actions/urls";
import { toast } from "react-toastify";

/*
 * set params to values to be fetched and data to values already fetched
 */
export const setParamsData = (params, data, queryParam) => {
    // if(!filterOptions) {
    if (queryParam) {
        params.push(queryParam);
    } else {
        params.push("topics", "countries", "languages", "platforms", "publications", "influencers", "addons");
    }

    params.push("company");

    params.push("search_analytics");
    // params.push("package_addons");
    // params.push("package_features");
};

export const getMetaDataFetchPayload = async (queryParam, isPublic) => {
    //params to fetch
    let params = [];
    let dt = {};
    if (isPublic) {
        params = ["company", "countries"];
    } else setParamsData(params, dt, queryParam);
    // setParamsData(params, dt, queryParam);

    if (params.length === 0) {
        return new Promise((res, rej) => res(dt));
    }

    let url = "meta_api";
    if (isPublic) url = "public_meta_api";

    let payload = await axios
        .get(`${getUrl(url)}&values=${params}`)
        .then((res) => res.data)
        .catch((error) => {
            console.log(error);
            if (!isPublic) {
                localStorage.clear();
                sessionStorage.clear();
                document.cookie = "accessToken" + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                if (error.response && error.response.data && error.response.data) toast.error(error.response.data, { containerId: "mainContent" });
                else toast.error("Oops! We encountered an error. Please refresh the page and retry logging in.", { containerId: "mainContent" });
                // setTimeout(() => {
                //     window.location.href = window.location.origin + "/signin";
                // }, 1000);
            } else return error;
        });

    payload.queryParam = queryParam;

    if (payload.company?.influencer_type_filter) localStorage.setItem("influencer_type_filter", payload.company.influencer_type_filter);
    localStorage.setItem("filterOptions", JSON.stringify(payload));

    Object.keys(payload).forEach((key) => {
        dt[key] = payload[key];
    }, this);

    return dt;
};
